import React, { useState, useEffect } from 'react';
import LoadingScreen from './LoadingScreen';

const PageWrapper = ({ children }) => {
  const [isInitialLoading, setIsInitialLoading] = useState(true);
  const [content, setContent] = useState(null);

  useEffect(() => {
    // Only show full-screen loading on initial page load
    if (!content) {
      setContent(children);
      const timer = setTimeout(() => {
        setIsInitialLoading(false);
      }, 1000);
      return () => clearTimeout(timer);
    } else {
      // Update content without triggering loading screen
      setContent(children);
    }
  }, [children]);

  if (isInitialLoading && !content) {
    return <LoadingScreen />;
  }

  return content;
};

export default PageWrapper; 